import { FC, PropsWithChildren, ReactNode } from 'react';
import { Tooltip, TooltipArrow, TooltipContent, TooltipTrigger } from './ui/tooltip';
import { HelpCircle } from 'lucide-react';
import classNames from 'classnames';
export const HelpTooltip: FC<PropsWithChildren<{
  className?: string;
  tooltipContent: ReactNode;
  showArrow?: boolean;
}>> = ({
  children,
  className,
  tooltipContent,
  showArrow
}) => <Tooltip data-sentry-element="Tooltip" data-sentry-component="HelpTooltip" data-sentry-source-file="help-tooltip.tsx">
    <TooltipTrigger className={classNames('inline-flex items-center group', className)} data-sentry-element="TooltipTrigger" data-sentry-source-file="help-tooltip.tsx">
      {children} <HelpCircle size={16} className="ml-1.5 opacity-70 group-hover:opacity-100" data-sentry-element="HelpCircle" data-sentry-source-file="help-tooltip.tsx" />
    </TooltipTrigger>
    <TooltipContent className="normal-case max-w-[280px] text-left dark:bg-gray-999 dark:text-white dark:border-none dark:border-zinc-200" data-sentry-element="TooltipContent" data-sentry-source-file="help-tooltip.tsx">
      {tooltipContent}
      {showArrow && <TooltipArrow />}
      <div className="hidden dark:block absolute left-0 top-0 w-full h-1 bg-gradient-to-r from-sky-10 to-gray-999" />
    </TooltipContent>
  </Tooltip>;